// Sync schedule units (matches CLAUS `TimeUnit`).
export const SCHEDULE_UNITS = [
	{ value: 'minute', label: 'minute(s)' },
	{ value: 'hour', label: 'hour(s)' },
	{ value: 'day', label: 'day(s)' },
	{ value: 'week', label: 'week(s)' },
];

// Auth-field keys whose values are secrets: rendered as password inputs and never pre-filled on edit
// (blank means "keep existing"). Matched case-insensitively against the template's auth field keys.
export const SECRET_AUTH_KEY_HINTS = [
	'apikey',
	'api_key',
	'password',
	'secret',
	'clientsecret',
	'client_secret',
	'privatekey',
	'private_key',
	'token',
];

export function isSecretAuthKey(key) {
	const k = String(key || '').toLowerCase();
	return SECRET_AUTH_KEY_HINTS.some((hint) => k.includes(hint));
}

// Template sort order by entity type (jobs first — the primary use case here).
export const TEMPLATE_TYPE_ORDER = { job: 0, candidate: 1, employee: 2 };

// process-jobs only change-tracks these Erin fields (surfaced in the UI so operators aren't surprised
// that a change to an untracked field won't re-sync).
export const CHANGE_TRACKED_FIELDS = ['title', 'description', 'jobType', 'status', 'publicLink', 'externalSource'];
